<template>
  <div class="bg">
    <div class="head">
      <div class="left">
        <div class="info" @click="backHome()">
          <img
            class="img"
            title="首页"
            src="@/assets/img/schoolBigData2/logo.png"
          />
          <div class="txt">双重预防体系云平台</div>
        </div>
      </div>
      <div class="center">
        <div v-for="(item, index) in titleArr" :key="index" class="list">
          <div
            class="list-li"
            :class="{ active: select == index }"
            @click="sel(item.path, index)"
          >
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="right"></div>
    </div>
    <div class="content-box">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  components: {},
  data() {
    return {
      titleArr: [],
      select: 1
    };
  },
  created() {
    if (this.userInfo.eduBuresuType == -1) {
      this.titleArr = [
        { type: "btn", title: "首页", path: "/schoolIndex_2" },
        { type: "btn", title: "基础信息", path: "/basics_info_2" },
        { type: "btn", title: "风险隐患", path: "/risk_hidden_danger_2" },
        { type: "btn", title: "雪亮工程", path: "/monitoring_center_2" },
        { type: "btn", title: "安全地图", path: "/safety_map_data_2" }
      ];
    } else {
      this.titleArr = [
        { type: "btn", title: "首页", path: "/schoolIndex_2" },
        { type: "btn", title: "基础信息", path: "/basics_info_2" },
        { type: "btn", title: "风险隐患", path: "/risk_hidden_danger_2" },
        { type: "btn", title: "雪亮工程", path: "/monitoring_center_2" },
        { type: "btn", title: "安全地图", path: "/safety_map_data_2" },
        { type: "btn", title: "食品安全", path: "/food_safety_data_2" }
      ];
    }
    if (JSON.parse(sessionStorage.getItem("schoolBigSelect"))) {
      this.select = JSON.parse(sessionStorage.getItem("schoolBigSelect"));
    }
  },
  mounted() {},
  watch: {},
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  methods: {
    sel(path, index) {
      this.select = index;
      this.$Common.pageJump(path, "", 0);
      this.$store.commit("setSelect", true);
      sessionStorage.setItem("schoolBigSelect", JSON.stringify(this.select));
    },
    backHome() {
      this.$Common.pageJump("/schoolIndex_2", 0);
    }
  },
  destroyed() {}
};

var targetHeightScale; //存放缩放的比例
var autoResize = {
  resize: function(docWidth, docHeight, targetSelector) {
    var docScale = docHeight / docWidth,
      designWidth = 1920,
      designHeight = 940,
      els = document.querySelectorAll(targetSelector),
      scale = docWidth / designWidth,
      scaleX = docWidth / designWidth,
      scaleY = docHeight / designHeight,
      _this = this;
    (targetHeightScale = scale), //将缩放比例保存，动态计算宽高时需要使用
      this.convertArray(els).forEach(function(el) {
        _this.extend(el.style, {
          width: designWidth + "px",
          height: docScale * designWidth + "px",
          position: "absolute",
          top: 0,
          left: 0,
          transformOrigin: "0 0",
          webkitTransformOrigin: "0 0",
          transform: "scale(" + scale + ")",
          webkitTransform: "scale(" + scale + ")",
          overflow: "hidden",
          webkitOverflowScrolling: "touch"
        });
      });
  },
  convertArray: function(arrayLike) {
    return Array.prototype.slice.call(arrayLike, 0);
  },
  extend: function() {
    var args = Array.prototype.slice.call(arguments, 0);
    return args.reduce(function(prev, now) {
      for (var key in now) {
        if (now.hasOwnProperty && now.hasOwnProperty(key)) {
          prev[key] = now[key];
        }
      }
      return prev;
    });
  },
  scaleResize: function(clientWidth, clientHeight, targetSelector) {
    window.addEventListener(
      "resize",
      this.resize(clientWidth, clientHeight, targetSelector)
    ); //监听窗口的变化
  }
};
var setElementSize = {
  //参数可选，最多选择5个参数。参数按序赋值，如果不需缩放，scale需传入1
  setSize: function(target, scale, target1, target2, target3) {
    var targetScale = scale || 1; //不传scale，不缩放，默认为1
    var targetHeight;
    if (target) {
      targetHeight = innerHeight / targetScale;
    }
    // console.log(targetHeight)
    // if (target1) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height();
    // }
    // if (target1 && target2 && target3) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height() -  document.querySelector(target2).height() -  document.querySelector(target3).height();
    // } else if (target1 && target2) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height() -  document.querySelector(target2).height();
    // } else if (target1) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height();
    // }
    document.querySelector(".bigdata_page").style.height = targetHeight;

    // var cancas =  document.getElementsByTagName('canvas')
    // var ss = document.getElementsByTagName('canvas')

    // console.log(ss)

    // document.getElementsByTagName('canvas').setAttribute('height','100%')
    // document.getElementsByTagName('canvas').setAttribute('width','100%')
    // console.log(cancas)
    // cancas.width = '100px'
    // cancas.height = '100px'

    // console.log(123)
    // console.log(document.querySelector('.bigdata_page').offsetHeight)
  }
};
var is_fullScreen = false;

window.onresize = function() {
  if (is_fullScreen) {
    changeHeight();
  } else {
    cancelChangeHeight();
  }
  autoResize.scaleResize(innerWidth, innerHeight, ".bigdata_page");
  setElementSize.setSize(".bigdata_page", targetHeightScale);
  // setElementSize.setSize('.left_top', targetHeightScale, '.top')
  // setElementSize.setSize('.map', targetHeightScale, '.top', '.left_bottom');
  // setElementSize.setSize('.right_body', targetHeightScale, '.top');
};
autoResize.scaleResize(innerWidth, innerHeight, ".bigdata_page");
setElementSize.setSize(".bigdata_page", targetHeightScale);
// 全屏状态时更改高度
function changeHeight() {
  is_fullScreen = true;
}

// 取消全屏时恢复
function cancelChangeHeight() {
  is_fullScreen = false;
}
</script>

<style lang="scss" scoped>
.bg {
  width: 100%;
  height: 100%;
  background: url("~@/assets/img/schoolBigData2/bg.png") center center
    no-repeat;
  background-size: 100% 100%;
  min-width: 1200px;
  min-height: 768px;
}
.head {
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  .left {
    display: flex;
    justify-content: center;
    align-items: center;
    .info {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        transform: scale(1.05);
      }
      .img {
        width: 107px;
        height: 22px;
      }
      .txt {
        margin-top: 7px;
        font-size: 18px;
        font-weight: 400;
        color: #86bb4f;
        font-style: italic;
      }
    }
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .list {
    width: 116px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    .icon-img {
      cursor: pointer;
      &:hover {
        transform: scale(1.05);
      }
    }
    .list-li {
      margin: 0 10px;
      width: 118px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 16px;
      color: #1573da;
      position: relative;
      transition: all 0.3s;
      &:hover {
        font-size: 18px;
        font-weight: 400;
        color: #67e2e9;
      }
      &.active {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #67e2e9;
        background: url("~@/assets/img/schoolBigData2/title-bg.png") center center
          no-repeat;
        background-size: 100% 100%;
        .active-img {
          transform: scale(1.3);
          display: block;
          position: absolute;
          width: 130px;
          height: 70px;
          top: 0;
          left: 5px;
        }
      }
      .active-img {
        display: none;
      }
    }
  }
}
.line {
  width: 100%;
  height: 2px;
  background: url("~@/assets/img/schoolBigData/school-big-title.png") bottom
    center no-repeat;
  background-size: 100% 100%;
}
.content-box {
  width: 100%;
  height: calc(100% - 90px);
}
//   school-title-shadow.png    按钮阴影
</style>
